import { Injectable, Output } from '@angular/core';
import { WebsocketService } from './websocket.service';
import { Observable, Subject } from 'rxjs/Rx';
import { Usuario } from '../_model/Usuario';
import { NetworkHelperService } from './network-helper.service';
import * as alertfy from 'alertifyjs';





@Injectable()
export class ChatService {
  mensaje;
  messages: Subject<any>;
  public usuario: Usuario = new Usuario;
  notificacionesSonido;
  mensajeSonido;
  mensajerecivido;
  // Our constructor calls our wsService connect method
  constructor(private wsService: WebsocketService, private network: NetworkHelperService) {

    this.network.callSecureService(
      'user',
      'GET',
      null)
      .subscribe((response: any) => {
        // console.log('Obetmcion del usuario');
        this.messages = <Subject<any>>wsService
      .connect(response.Mensaje)
      .map((response: any): any => {
        return response;
      })
    }, err => {
      console.log(err);
      // Swal('Error', 'algo paso al enviar el cambio de estatus', 'error');
    });


   }

  getMensajes() {
    let pay = this.mensaje;
    return pay;
  }

  // Our simplified interface for sending
  // messages back to our socket.io server
  sendMsg(msg) {

    this.messages.next(msg);
  }

}



// WEBPACK FOOTER //
// C:/xampp/htdocs/sm8-v1-front/src/app/_services/chat.service.ts